import {
  BrowserRouter as
    Switch,
  Route
} from "react-router-dom";
import React from 'react'
import Login from './Login';
import ForgotPassword from "./ForgotPassword";
import isEmpty from 'lodash.isempty';

export default function () {

  const params = new URLSearchParams(window.location.search)
  const token = params.get('reset_password_token')
  return (<div>
    <Switch>
      <Route path="/auth/password/edit">
        <ForgotPassword />
      </Route>
      {!isEmpty(token) &&
        <Route exact path="/login">
          <Login />
        </Route>
      }
      {isEmpty(token) &&
        <Route path="/">
          <Login />
        </Route>
      }
    </Switch>
  </div>)
}